export default __webpack_public_path__ + "static/media/flag_uru.2998b3fe.svg";